import type { RouteObject } from 'react-router';

import { contentAssetsRoute } from './assets/assets.route';
import { contentEditRoute } from './edit/edit.route';
import { contentListRoute } from './index/index.route';
import { contentNewRoute } from './new/new.route';

/**
 * The four content surfaces, aggregated so the composition root takes one import
 * line rather than four.
 *
 * The file is `.routes.tsx` **plural** because it exports an array — the name
 * alone tells the router what shape to expect at import time.
 *
 * **`/content/new` is declared before the parameterised routes**, so the literal
 * segment is never read as an identifier.
 *
 * There is **no `/content/:contentItemId`**: the pack's sitemap carries none, so
 * the edit surface is three crumbs deep and the assets surface four, with its
 * third crumb pointing at the title's *edit* route rather than at a page that
 * does not exist.
 */
export const contentRoutes: RouteObject[] = [
  contentListRoute,
  contentNewRoute,
  contentEditRoute,
  contentAssetsRoute,
];
